<template>
    <div>
        <section class="signature-employees account-section" v-if="loaded">
            <div class="account-container">

                <div class="signature-list">

                    <div class="mb-5 d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between">
                        <div>
                            <h1 class="m-0 h2">{{ signature.name }}</h1>
                            <div class="mt-1 color-light-bluegray text-xsmall" v-if="signature.slug && signature.status === 'Published'">{{ total_employee_signatures }} Employee Uses</div>
                            <div class="mt-1 color-light-bluegray text-xsmall" v-else>{{ total_employee_signatures }} Employees</div>
                        </div>
                        <div class="ml-lg-3 mt-3 mt-lg-0 d-flex align-items-center">
                            <form class="form-inline mt-2 mt-md-0" v-if="search_box_displayed">
                                <input class="form-control search-input" type="search" placeholder="Search Employees" aria-label="Search" v-model="searchtext">
                                <button class="btn btn-mediumblue btn-search btn-search-open" type="submit" v-on:click.prevent="getResults()"><span class="sr-only">Search</span></button>
                            </form>
                            <button class="btn btn-mediumblue btn-search" v-if="!search_box_displayed" v-on:click.prevent="search_box_displayed = true"><span class="sr-only">Search</span></button>
                            <a v-bind:href="'/signature/employees/' + signature.id + '/export'" class="btn btn-primary ml-2">Export</a>
                            <a class="btn btn-primary ml-2 d-none d-sm-inline-block" href="/signatures">Manage Signatures</a>
                        </div>
                    </div>
                    <div class="mb-3 mt-n3 d-flex align-items-center justify-content-between color-light-bluegray text-xsmall inset-area px-3 py-2" v-if="searchtext_applied">
                        <div>
                            <strong>{{ employee_signatures.total }}</strong> employee signatures 
                            <template v-if="searchtext_applied">
                                with text <strong>{{ searchtext_applied }}</strong>
                            </template> 
                        </div>
                        <div>
                            <button class="btn btn-sm btn-mediumblue" v-on:click.prevent="clearFilters()">Clear</button>
                        </div>
                    </div>
                    <div class="card card-padding-table">
                        <table class="employees-table table m-0">
                            <tr>
                                <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pl-0 pb-1 pt-2">
                                    Email
                                </th>
                                <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2" v-if="!organization.old_mode_no_employee_sigs">
                                    Name
                                </th>
                                <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2" v-if="!organization.old_mode_no_employee_sigs">
                                    Title
                                </th>
                                <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2">
                                    Created
                                </th>
                                <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2">
                                    Last Used
                                </th>
                                <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2">
                                    Uses
                                </th>
                                <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2 pr-0 text-right">
                                    Actions
                                </th>
                            </tr>
                            <tr v-for="employee_signature in employee_signatures.data" v-bind:key="employee_signature.id">
                                <td class="email text-xsmall align-middle pl-0">
                                    <a v-bind:href="'/employees/' + employee_signature.employee_id" class="email-link">{{ employee_signature.email }}</a>
                                </td>
                                <td class="email text-xsmall align-middle" v-if="!organization.old_mode_no_employee_sigs">
                                    {{ employee_signature.full_name }}
                                </td>
                                <td class="email text-xsmall align-middle" v-if="!organization.old_mode_no_employee_sigs">
                                    {{ employee_signature.title }}
                                </td>
                                <td class="date text-xsmall align-middle">
                                    {{ employee_signature.created_at | toDate }}
                                </td>
                                <td class="date text-xsmall align-middle">
                                    {{ employee_signature.updated_at | toDate }}
                                </td>
                                <td class="date text-xsmall align-middle">
                                    {{ employee_signature.uses }}
                                </td>
                                <td class="date text-xsmall align-middle text-right pr-0">
                                    <button class="btn btn-sm btn-mediumblue" v-bind:class="{ 'btn-disabled': !hasGeneratorLink() }" v-on:click.prevent="openEmployeeSigLinkModal(employee_signature)" v-if="!organization.old_mode_no_employee_sigs">Share</button>
                                    <a v-bind:href="'/employees/' + employee_signature.employee_id + '/signature/' + employee_signature.id" class="btn btn-mediumblue btn-sm" v-if="!organization.old_mode_no_employee_sigs">Edit</a>
                                    <a href="#" class="btn btn-mediumblue btn-sm" v-on:click.prevent="deleteEmployeeSignature(employee_signature)">Delete</a>
                                </td>
                            </tr>
                            <tr v-if="employee_signatures.data && employee_signatures.data.length === 0">
                                <td class="text-xsmall align-middle pl-0" colspan="7">
                                    <template v-if="searchtext">
                                        No employee signatures found.
                                    </template>
                                    <template v-else-if="signature.slug && signature.status === 'Published'">
                                        No employees have used this signature template yet.
                                    </template>
                                    <template v-else>
                                        No employees yet.
                                    </template>
                                </td>
                            </tr>
                        </table>
                    </div><!-- .signature-card -->
                    <div class="mt-4 table-pagination">
                        <pagination :data="employee_signatures" @pagination-change-page="getResults" />
                    </div>
                    <div class="mt-4">
                        <a v-bind:href="templateLink()" class="add-new btn btn-primary">New employee signature</a>
                    </div>

                </div>

                <div id="employee-sig-link-modal" class="employee-sig-link-modal modal ui-light-theme" v-bind:class="{ show: showEmployeeSigLinkModal }" tabindex="-1" role="dialog" aria-modal="true" v-if="showEmployeeSigLinkModal" v-on:click.self.prevent="showEmployeeSigLinkModal = false">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Private Employee Signature Link</h5>
                                <button type="button" class="close" v-on:click.prevent="showEmployeeSigLinkModal = false" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <template v-if="employeeSigLink">
                                    <p>This is the private link that {{ employeeSigLinkModalSig.full_name }} can visit to copy or modify their signature:</p>
                                    <p class="position-relative"><input type="text" name="share-slug" class="form-control form-control-lg" v-model="employeeSigLink"><button class="btn btn-mediumblue btn-sm copy-button" v-on:click.prevent="copyEmployeeSigLink()">
                                        <template v-if="employeeSigLinkCopied">
                                            Copied!
                                        </template>
                                        <template v-else>
                                            Copy
                                        </template>
                                    </button></p>
                                </template>
                                <template v-else>
                                    <p class="m-0">It looks like this signature doesn't have a published generator link. This is required for an employee to be able to view or edit their signature. If you would like to be able to share employee signatures, please return to the signature, visit the <strong>Settings</strong> item near the top right of the screen and publish your generator.</p>
                                </template>
                            </div>
                        </div>
                    </div>
                </div><!-- #employee-sig-link-modal -->

            </div>
        </section>

    </div>
</template>

<script>
    import { DateTime } from "luxon";
    import * as clipboard from "clipboard-polyfill";
    export default {
        props: {
            load_signature_id: {
                type: String,
                default: null,
            },
            load_env: {
                type: String,
                default: 'production',
            },
        },
        data: function () {
            return {
                signature: null,
                organization: null,
                user: null,
                employee_signatures: null,
                total_employee_signatures: null,
                loaded: false,
                search_box_displayed: false,
                searchtext: '',
                searchtext_applied: '',
                employeeSigLink: '',
                employeeSigLinkModalSig: null,
                employeeSigLinkCopied: false,
                showEmployeeSigLinkModal: false,
            }
        },
        mounted() {
            this.getResults(1);
        },
        filters: {
            toDate: function(date) {
                return DateTime.fromISO(date).toLocaleString();
            },
            toLowerCase: function(string) {
                return string.toLowerCase().trim();
            }
        },
        methods: {
            hasGeneratorLink: function() {
                if (this.signature && this.signature.status == 'Published' && this.signature.slug) {
                    return true;
                } else {
                    return false;
                }
            },
            clearFilters: function() {
                this.searchtext = '';
                this.searchtext_applied = '';
                this.getResults();
            },
            getResults: function(page) {
                var self = this;
                axios.post('/signature/employees/' + this.load_signature_id + '/data', { page: page, search: self.searchtext})
                .then(function(response) {
                    self.employee_signatures = response.data.employee_signatures;
                    self.searchtext_applied = self.searchtext;
                    if (self.signature === null || self.organization === null || self.user === null || self.total_employee_signatures === null) {
                        self.signature = response.data.signature;
                        self.organization = response.data.organization;
                        self.user = response.data.user;
                        self.total_employee_signatures = response.data.total_employee_signatures;
                        self.loaded = true;
                    }
                }.bind(this)).catch(function(data) {
                    console.log('error');
                });
            },
            openEmployeeSigLinkModal: function(employee_signature) {
                this.showEmployeeSigLinkModal = true;
                this.employeeSigLinkCopied = false;
                this.employeeSigLinkModalSig = employee_signature;
                if (this.signature && this.signature.status == 'Published' && this.signature.slug) {
                    if (this.load_env == 'development') {
                        this.employeeSigLink = 'http://' + this.signature.slug + '.signatureemail.lndo.site/signature/' + employee_signature.slug;
                    } else {
                        this.employeeSigLink = 'https://' + this.signature.slug + '.signature.email/signature/' + employee_signature.slug;
                    }
                } else {
                    this.employeeSigLink = null;
                }
            },
            copyEmployeeSigLink: function() {
                var dt = new clipboard.DT();
                dt.setData("text/plain", this.employeeSigLink);
                clipboard.write(dt);
                this.employeeSigLinkCopied = true;
            },
            templateLink: function() {
                if (this.signature.slug && this.signature.status === 'Published') {
                    if (this.load_env == 'development') {
                        return "http://" + this.signature.slug + ".signatureemail.lndo.site";
                    } else {
                        return "https://" + this.signature.slug + ".signature.email";
                    }
                } else {
                    return "/signatures/view/" + this.signature.id;
                }
            },
            deleteEmployeeSignature: function(employee_signature) {
                var confirmation = confirm("Are you sure you want to delete this " + employee_signature.full_name + " employee signature permanently?");
                if (confirmation == true) {
                    var self = this;
                    axios.post('/employees/' + employee_signature.employee_id + '/signature/' + employee_signature.id + '/delete')
                    .then(function(response) {
                        if (response.data.status == 'success') {
                            var employeeSigIndex = self.employee_signatures.findIndex(function(theemployeesig) {
                                return theemployeesig.id === employee_signature.id;
                            }, employee_signature);
                            if (employeeSigIndex !== -1) {
                                self.employee_signatures.splice(employeeSigIndex, 1);
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: 'Employee signature deleted!',
                                    type: 'success',
                                });
                            }
                        }
                    }.bind(this)).catch(function(data) {
                        console.log('error');
                    });
                }
            }
        }
    }
</script>
